<div class="index-shell">

    <app-header [breadcrumbs]="['Commissioners']" mainHeading="Commissioners" [links]="['/commissioners']">
        <div headingButton>
            @if ((user()?.permissions?.permissions ?? []).includes('commissioner.create')) {
                <button class="add-button" cll-icon-button (click)="navigateToAddCommissioner()">
                    <cll-icon type="outlined">add</cll-icon>
                </button>
            }
        </div>
    </app-header>
    <div>
        <cll-horizontal-tabs
            [appearance]="'contained'"
            [tabItems]="tabItems"
            [currentTabId]="(currentTabId$ | async)!"
            (currentTabIdChange)="currentTabIdChange($event)" />
        <div class="search-container">
            <cll-form-field label="Type a keyword...">
                <cll-icon cllPrefix>search</cll-icon>
                <input [formControl]="searchControl"
                       cllFormInput
                       type="text">

                @if (searchControl.value) {
                    <button (click)="searchControl.reset()"
                            cll-icon-button
                            cllTooltip="Clear search query"
                            cllSuffix>
                        <cll-icon>clear</cll-icon>
                    </button>
                }
            </cll-form-field>
        </div>

        @if (pageResult(); as request) {
            @if (request.isLoading) {
                <cll-spinner />
            }

            @if (request.error; as error) {
                <app-error-panel [error]="error" />
            }
            <div>
                @if (request.value; as page) {
                    <div>
                        <table class="cll-table">
                            <colgroup>
                                <col style="width: 48px;">
                            </colgroup>

                            <thead>
                            <tr>
                                <th>Reference</th>
                                <th>Commissioner name</th>
                                <th>Main email address</th>
                                <th>Telephone numbers</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                            </thead>

                            <tbody>
                                @if (page.data.length === 0) {
                                    <tr>
                                        <td colspan="6" class="no-data-row">
                                          <div class="no-data-wrapper">
                                            No Commissioners found.
                                          </div>
                                        </td>
                                      </tr>
                                  } @else {
                                @for (commissioner of page.data; track commissioner.id) {
                                    <tr [routerLink]="['/commissioners', commissioner.id]" class="clickable">
                                        <td>{{ commissioner.reference }}</td>
                                        <td>{{ commissioner.name }}</td>
                                        <td>{{ commissioner.email }}</td>
                                        <td>
                                            @if (commissioner.contact_numbers[0]) {
                                                {{ commissioner.contact_numbers[0].number }}
                                            }
                                        </td>
                                        <td>
                                            @if (commissioner.status) {
                                                <cll-badge colour="success">Active</cll-badge>
                                            } @else {
                                                <cll-badge colour="error">Inactive</cll-badge>
                                            }
                                        </td>
                                        <td class="align-right">
                                            <button cll-icon-button
                                                    [cllMenuTriggerFor]="menu"
                                                    (click)="$event.stopPropagation()">
                                                <cll-icon>more_vert</cll-icon>
                                            </button>

                                            <ng-template #menu>
                                                <cll-menu>
                                                    <a cllMenuItem
                                                       [routerLink]="['/commissioners/', commissioner.id]">
                                                        <cll-icon>open_in_new</cll-icon>

                                                        View
                                                    </a>
                                                    @if (user()?.permissions?.permission_name?.includes('Administrator')) {
                                                        @if (commissioner.status) {
                                                            <button cllMenuItem
                                                                    (click)="changeStatus(commissioner, false)">
                                                                <cll-icon type="outlined">toggle_off</cll-icon>
                                                                Mark as inactive
                                                            </button>
                                                        } @else {
                                                            <button cllMenuItem
                                                                    (click)="changeStatus(commissioner, true)">
                                                                <cll-icon type="outlined">toggle_on</cll-icon>
                                                                Mark as active
                                                            </button>
                                                        }
                                                    }
                                                </cll-menu>
                                            </ng-template>
                                        </td>
                                    </tr>
                                }
                            }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        }
    </div>

    <app-pagination-card
        (page)="setPage($event)"
        [meta]="meta()"
    />
</div>
